export const FETCH_DRIVERS_DOCUMENTS_TYPES_DATA = "FETCH_DRIVERS_DOCUMENTS_TYPES_DATA";
export const FETCH_DRIVERS_DOCUMENTS_TYPES_SUCCESS = "FETCH_DRIVERS_DOCUMENTS_TYPES_SUCCESS";
export const FETCH_DRIVERS_DOCUMENTS_TYPES_FAILURE = "FETCH_DRIVERS_DOCUMENTS_TYPES_FAILURE";